import { api } from './api'
import { ConsultationTerminologySystem } from '../types/consultation'

export type AutocompleteSuggestionType =
  | 'terminology'
  | 'template'
  | 'phrase'
  | 'llm_rewrite'
  | 'llm_summarize'

export interface AutocompleteCodeRef {
  system: ConsultationTerminologySystem | string
  code: string
  version?: string
  display?: string
  icd10Mappings?: string[]
}

export interface AutocompleteSuggestion {
  type: AutocompleteSuggestionType
  preview_text: string
  full_text: string
  confidence?: number
  code_refs?: AutocompleteCodeRef[]
  template_id?: string
  custom_phrase_id?: string
  metadata?: Record<string, unknown>
}

export interface AutocompleteRequestEncounter {
  reasonForVisit?: string
  problems?: string[]
  meds?: string[]
  vitals?: Record<string, unknown>
  codes?: AutocompleteCodeRef[]
}

export type NoteSectionType =
  | 'chief_complaint'
  | 'hpi'
  | 'ros'
  | 'exam'
  | 'assessment'
  | 'plan'
  | 'notes'

export interface AutocompleteRequest {
  userId?: string
  specialty?: string
  clinic?: string
  encounter?: AutocompleteRequestEncounter
  sectionType?: NoteSectionType
  textBeforeCursor?: string
  textAfterCursor?: string
  typedPrefix?: string
  cursorPosition?: number
  locale?: string
  allowLlm?: boolean
  terminologySystem?: ConsultationTerminologySystem
  terminologyVersion?: string
}

export interface AutocompleteResponse {
  suggestions: AutocompleteSuggestion[]
}

export const autocompleteService = {
  autocomplete: async (payload: AutocompleteRequest): Promise<AutocompleteSuggestion[]> => {
    const response = await api.post<AutocompleteResponse>('/notes/autocomplete', payload)
    return response.data.suggestions ?? []
  },
}

